<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <app-frontend-filter (onFiltersChanged)="onFiltersChanged($event)"
                             [filters]="allFilters">
        </app-frontend-filter>
        <div class="user-panel-default">
          <div class="card-table">
            <div class="card-body-table">
              <div class="d-flex align-items-center justify-content-between mb-2 p-2"
                   style="border: 1px solid #e5e5e5; border-radius: 10px; background: #fafafa;">
                <div class="d-flex align-items-center gap-2">
                  <span [class]="socketBadgeClass" class="fs-5">{{ socketLabel | translate }}</span>
                  @if (socketLabel === 'Error') {
                    <small *ngIf="socketError" class="text-muted">({{ socketError }})</small>
                  }
                </div>

                <div class="d-flex align-items-center gap-2" style="min-width: 420px;">
                  <input
                    (input)="onSocketUrlChange($any($event.target).value)"
                    [value]="socketUrl"
                    class="form-control"
                    placeholder="Socket URL مثل: http://127.0.0.1:3000"
                    style="max-width: 360px;"
                  />

                  <button (click)="connectSocket()"
                          [disabled]="socketState === 'CONNECTED' || socketState === 'CONNECTING'"
                          class="btn btn-sm btn-primary">
                    {{ 'Connect' | translate }}
                  </button>

                  <button (click)="disconnectSocket()"
                          [disabled]="socketState === 'DISCONNECTED'"
                          class="btn btn-sm btn-danger">
                    {{ 'Disconnect' | translate }}
                  </button>
                </div>
              </div>
              <app-frontend-table [dataSource]="orders"
                                  [displayColumnEndpoints]="displayEndPoint"
                                  [displayColumnTypes]="displayColumnTypes"
                                  [displayColumns]="displayedColumns"
                                  [displayDataSources]="displayDataSources"
                                  [tableProperties]="tableProperties">
              </app-frontend-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
